import { render, staticRenderFns } from "./knifeTable.vue?vue&type=template&id=9179fb4e&scoped=true&"
import script from "./knifeTable.vue?vue&type=script&lang=js&"
export * from "./knifeTable.vue?vue&type=script&lang=js&"
import style0 from "./knifeTable.vue?vue&type=style&index=0&id=9179fb4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9179fb4e",
  null
  
)

export default component.exports